import { render, staticRenderFns } from "./image-widget.vue?vue&type=template&id=d6b275de&scoped=true"
import script from "./image-widget.vue?vue&type=script&lang=js"
export * from "./image-widget.vue?vue&type=script&lang=js"
import style0 from "./image-widget.vue?vue&type=style&index=0&id=d6b275de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b275de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6b275de')) {
      api.createRecord('d6b275de', component.options)
    } else {
      api.reload('d6b275de', component.options)
    }
    module.hot.accept("./image-widget.vue?vue&type=template&id=d6b275de&scoped=true", function () {
      api.rerender('d6b275de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/image-widget.vue"
export default component.exports